import api from '.'
import {
	DirectDeal,
	DirectDealReq,
	DirectDealsOverview,
	DirectDealsReq,
	DirectDealSummary,
} from './directDeals.types'

// Query Key factory
export const DirectDealKeys = {
	all: (id: Id) => ['direct-deals', id],
	list: (id: Id, query?: DirectDealsReq | null) => [...DirectDealKeys.all(id), query],
	directDeal: (marketBasketId: Id, id: Id, query?: DirectDealReq | null) => [
		...DirectDealKeys.all(marketBasketId),
		id,
		query,
	],
	summary: (marketBasketId: Id) => [
		...DirectDealKeys.all(marketBasketId),
		'summary',
		marketBasketId,
	],
}

const DirectDealApi = {
	list: (basketId: Id, query: DirectDealsReq) =>
		api
			.get<APIRes<DirectDealSummary[]>>(`/market-baskets/${basketId}/direct-deals`, {
				params: { ...query },
			})
			.then((res) => res.data.data),
	directDeal: (directDealId: Id, query: DirectDealReq) =>
		api
			.get<APIRes<DirectDeal>>(`/market-baskets/direct-deals/${directDealId}`, {
				params: { ...query },
			})
			.then((res) => res.data.data),
	summary: (basketId: Id) =>
		api
			.get<APIRes<DirectDealsOverview>>(`/market-baskets/${basketId}/direct-deals/summary`)
			.then((res) => res.data.data),
	acceptDirectDeal: (directDealId: Id) =>
		api.post(`/market-baskets/direct-deals/${directDealId}/accept`),
	rejectDirectDeal: (directDealId: Id) =>
		api.post(`/market-baskets/direct-deals/${directDealId}/reject`),
}

export default DirectDealApi
